module.exports = __webpack_public_path__ + "f3035490c00395591ea7a3e21824262c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/quarantaene.jpg
// module id = 495
// module chunks = 0